import React from "react";

class UnitPricesTable extends React.Component {
    renderRows = () => {
        const { tableData = [] } = this.props;

        if (!tableData.length) {
            return (
                <tr>
                    <td colSpan="3"></td>
                </tr>
            );
        }

        return tableData.map((item, index) => (
            <tr key={`${item.description}-${index}`} tabIndex="0">
                <th className="table-first-column-text" scope="row">
                    {item.description}
                </th>
                <td className="table-other-column-text">{item.entryPrice}</td>
                <td className="table-other-column-text">{item.exitPrice}</td>
            </tr>
        ));
    };

    render() {
        const { header } = this.props;

        return (
            <div>
                <table className="table table-hover table-custom" tabIndex="0">
                    <thead className="theads">
                        <tr className="historical-table-header" tabIndex="0">
                            <th className="table-header-firstColumn-text" scope="col">
                                {header}
                            </th>
                            <th className="table-header-text" scope="col">
                                Entry Price
                            </th>
                            <th className="table-header-text" scope="col">
                                Exit Price
                            </th>
                        </tr>
                    </thead>

                    <tbody>{this.renderRows()}</tbody>
                </table>
            </div>
        );
    }
}

export default UnitPricesTable;